/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { DeleteManualEntryMutationResponse, DeleteManualEntryPathParams, DeleteManualEntry400, DeleteManualEntry401, DeleteManualEntry403, DeleteManualEntry404, DeleteManualEntry409, DeleteManualEntry500 } from "../../types/financialHubController/DeleteManualEntry.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { deleteManualEntry } from "../../client/financialHubController/deleteManualEntry.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const deleteManualEntryMutationKey = () => [{ url: '/api/organizations/:organizationId/financial/transactions/:transactionId' }] as const

export type DeleteManualEntryMutationKey = ReturnType<typeof deleteManualEntryMutationKey>

export function deleteManualEntryMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = deleteManualEntryMutationKey()
        return mutationOptions<DeleteManualEntryMutationResponse, ResponseErrorConfig<DeleteManualEntry400 | DeleteManualEntry401 | DeleteManualEntry403 | DeleteManualEntry404 | DeleteManualEntry409 | DeleteManualEntry500>, {organizationId: DeleteManualEntryPathParams["organizationId"], transactionId: DeleteManualEntryPathParams["transactionId"]}, TContext>({
          mutationKey,
          mutationFn: async({ organizationId, transactionId }) => {
            return deleteManualEntry(organizationId, transactionId, config)
          },
        })

}

/**
 * @summary Delete a manual ledger entry
 * {@link /api/organizations/:organizationId/financial/transactions/:transactionId}
 */
export function useDeleteManualEntry<TContext>(options: 
{
  mutation?: UseMutationOptions<DeleteManualEntryMutationResponse, ResponseErrorConfig<DeleteManualEntry400 | DeleteManualEntry401 | DeleteManualEntry403 | DeleteManualEntry404 | DeleteManualEntry409 | DeleteManualEntry500>, {organizationId: DeleteManualEntryPathParams["organizationId"], transactionId: DeleteManualEntryPathParams["transactionId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? deleteManualEntryMutationKey()

          const baseOptions = deleteManualEntryMutationOptions(config) as UseMutationOptions<DeleteManualEntryMutationResponse, ResponseErrorConfig<DeleteManualEntry400 | DeleteManualEntry401 | DeleteManualEntry403 | DeleteManualEntry404 | DeleteManualEntry409 | DeleteManualEntry500>, {organizationId: DeleteManualEntryPathParams["organizationId"], transactionId: DeleteManualEntryPathParams["transactionId"]}, TContext>
          

          return useMutation<DeleteManualEntryMutationResponse, ResponseErrorConfig<DeleteManualEntry400 | DeleteManualEntry401 | DeleteManualEntry403 | DeleteManualEntry404 | DeleteManualEntry409 | DeleteManualEntry500>, {organizationId: DeleteManualEntryPathParams["organizationId"], transactionId: DeleteManualEntryPathParams["transactionId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DeleteManualEntryMutationResponse, ResponseErrorConfig<DeleteManualEntry400 | DeleteManualEntry401 | DeleteManualEntry403 | DeleteManualEntry404 | DeleteManualEntry409 | DeleteManualEntry500>, {organizationId: DeleteManualEntryPathParams["organizationId"], transactionId: DeleteManualEntryPathParams["transactionId"]}, TContext>
      
}